/**
 * アイコンパスを解決する
 * @param {string|null} pathTemplate
 * @param {string|number} size
 * @param {string} [imageBaseUrl]
 * @returns {string|null}
 */
export function resolveIconPath(pathTemplate, size = "45", imageBaseUrl = "") {
  if (!pathTemplate) return pathTemplate;

  const resolved = pathTemplate.replace("[size]", size);
  if (imageBaseUrl && resolved.startsWith("/")) return `${imageBaseUrl}${resolved}`;
  return resolved;
}

/**
 * タグ配列をIDで引けるオブジェクトに変換
 * @param {Array} tags
 * @param {string|number} size
 * @param {string} [imageBaseUrl]
 * @returns {Object}
 */
export function buildTagsById(tags, size, imageBaseUrl = "") {
  return tags.reduce((result, tag) => {
    if (tag?.id == null) return result;

    result[String(tag.id)] = {
      ...tag,
      image: tag.image ? resolveIconPath(tag.image, size, imageBaseUrl) : null
    };
    return result;
  }, {});
}

/**
 * 重要度順に降順ソート
 * @param {Array} tags
 * @returns {Array}
 */
export function sortByImportanceDesc(tags) {
  return [...tags].sort((a, b) => (b.importance || 0) - (a.importance || 0));
}

/**
 * HTMLエスケープ
 * @param {string} value
 * @returns {string}
 */
export function escapeHtml(value) {
  return String(value || "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

/**
 * http/httpsのみ許可するURLサニタイズ
 * @param {string} value
 * @returns {string|null}
 */
export function sanitizeHttpUrl(value) {
  if (!value) return null;

  try {
    const parsedUrl = new URL(value, window.location.origin);
    return ["http:", "https:"].includes(parsedUrl.protocol) ? parsedUrl.toString() : null;
  } catch {
    return null;
  }
}